<article
  class="{{ type }}"
  id="{{ id }}{{ type }}"
  *ngIf="type != 'tile_list'"
  (mouseenter)="showDetails($event)"
  (mouseleave)="hideDetails($event)"
>
  <div class="image {{ category | replaceSpaces }}Gradient">
    <div>
      <img
        class="icon"
        [ngClass]="{ dashboard: canvasType == 'dashboard' }"
        src="/assets/images/canvas-tile/applicationIcons/{{
          category | replaceSpaces
        }}.png"
      />
    </div>
    <div class="details">
      <div class="actions">
        <img
          [matMenuTriggerFor]="actionsMenu"
          alt="action menu"
          src="/assets/images/canvas-tile/actions.png"
          width="29px"
          height="14px"
          class="dots"
        />
      </div>
      <mat-menu
        #actionsMenu="matMenu"
        xPosition="before"
        yPosition="below"
        overlapTrigger
        ><span class="menuClose" (click)="closeActionMenu()"
          ><fa-icon [icon]="faEllipsisH" class="fa-2x"></fa-icon
        ></span>
        <br />
        <button
          mat-menu-item
          (click)="closeActionMenu(); openDownloadDialog($event, id, title)"
        >
          Download
        </button>
        <button
          mat-menu-item
          [disabled]="!editable"
          (click)="closeActionMenu(); openDeleteDialog($event, id)"
        >
          Delete
        </button>
      </mat-menu>
      <div></div>
      <span
        class="detail_icon new"
        (click)="openCreateDialog($event, title, category_id, id, description)"
        ><fa-icon [icon]="faCopy"></fa-icon>Duplicate</span
      >
      <span
        class="detail_icon preview"
        (click)="openPreviewDialog($event, id, title, editable)"
        ><fa-icon [icon]="faEye"></fa-icon>Preview</span
      >
    </div>
  </div>
  <a
    [routerLink]="[returnCanvasUrl(editable), id]"
    style="text-decoration: none"
  >
    <div class="text">
      <div class="title" id="{{ id }}" [matTooltip]="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
      <div class="about">
        <div
          class="avatar-circle"
          *ngIf="isSystem"
          [ngStyle]="{ 'background-color': '#ff6e00' }"
        >
          <img
            class="system"
            src="/assets/images/canvas-tile/quantivate-tile.png"
          />
        </div>

        <div
          class="avatar-circle"
          *ngIf="!isSystem"
          [ngStyle]="{ 'background-color': getAvatarColor(author) }"
        >
          <span class="initials">{{ getInitials(author) }}</span>
        </div>

        <div class="userText" *ngIf="isSystem">
          {{ category }}<br />
          by Quantivate
          <div class="updated">Updated {{ formatUpdated(updated) }}</div>
        </div>
        <div class="userText" *ngIf="!isSystem">
          {{ category }}<br />
          by {{ author }}
          <div class="updated">Updated {{ formatUpdated(updated) }}</div>
        </div>

        <div class="bookmark">
          <fa-icon
            [icon]="faBookmark"
            *ngIf="favorited"
            id="favorited"
          ></fa-icon>
          <fa-icon [icon]="faBookmarkOutline" *ngIf="!favorited"></fa-icon>
        </div>
      </div>
    </div>
  </a>
</article>

<article
  class="{{ type }}"
  *ngIf="type == 'tile_list'"
  (click)="goToReport(editable, id)"
>
  <span class="image {{ category | replaceSpaces }}Gradient">
    <div>
      <img
        [ngClass]="{ dashboard: canvasType == 'dashboard' }"
        src="/assets/images/canvas-tile/applicationIcons/{{
          category | replaceSpaces
        }}.png"
      />
    </div>
  </span>
  <span class="title">
    <fa-icon [icon]="faBookmark" *ngIf="favorited" id="favorited"></fa-icon>
    <fa-icon [icon]="faBookmarkOutline" *ngIf="!favorited"></fa-icon>

    <div class="list-title" [matTooltip]="title">{{ title }}</div>
    <span class="info">
      <fa-icon
        [icon]="faInfoCircle"
        (click)="setClickStyle($event)"
        matTooltip="Description: {{ description }}"
        matTooltipClass="report-home-tooltip"
        matTooltipPosition="right"
      ></fa-icon>
    </span>
  </span>
  <span class="type">
    {{ category }}
  </span>
  <span class="createdBy" *ngIf="isSystem"> Quantivate </span>
  <span class="createdBy" *ngIf="!isSystem">
    {{ getShortName(author) }}
  </span>

  <span class="modified"> last updated {{ formatUpdated(updated) }} </span>
  <span class="details">
    <span
      class="detail_icon"
      (click)="openCreateDialog($event, title, category_id, id, description)"
      ><fa-icon [icon]="faCopy"></fa-icon> <span>Duplicate</span></span
    >
    <span
      class="detail_icon"
      (click)="openPreviewDialog($event, id, title, editable)"
      ><fa-icon [icon]="faEye"></fa-icon><span>Preview</span></span
    >
  </span>
  <span
    class="actions"
    [matMenuTriggerFor]="actionsMenu"
    (click)="$event.stopPropagation()"
  >
    <fa-icon [icon]="faEllipsisH" class="fa-2x"></fa-icon>
  </span>

  <mat-menu
    #actionsMenu="matMenu"
    xPosition="before"
    yPosition="below"
    overlapTrigger
    ><span class="menuClose" (click)="closeActionMenu()"
      ><fa-icon [icon]="faEllipsisH" class="fa-2x"></fa-icon
    ></span>
    <br />
    <button
      mat-menu-item
      (click)="closeActionMenu(); openDownloadDialog($event, id, title)"
    >
      Download
    </button>
    <button
      mat-menu-item
      [disabled]="!editable"
      (click)="closeActionMenu(); openDeleteDialog($event, id)"
    >
      Delete
    </button>
  </mat-menu>
</article>
